import { render, staticRenderFns } from "./ProcessManagement.vue?vue&type=template&id=60856b49&scoped=true"
import script from "./ProcessManagement.vue?vue&type=script&lang=js"
export * from "./ProcessManagement.vue?vue&type=script&lang=js"
import style0 from "./ProcessManagement.vue?vue&type=style&index=0&id=60856b49&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60856b49",
  null
  
)

export default component.exports